import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("hotc_admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#111111] bg-grid-dark px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#2c2c2e] bg-[#202124] p-8 sm:p-10">
        <Logo dark />
        <h1 className="mt-8 font-heading text-2xl font-bold text-white">Admin Login</h1>
        <p className="mt-1.5 text-sm text-[#98a2b3]">Manage catalogue, enquiries and business information.</p>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-sm font-medium text-[#c9cdd4]">Email</label>
            <input
              id="admin-email"
              data-testid="admin-email"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="min-h-[46px] w-full border border-[#3a3d42] bg-[#111111] px-4 py-3 text-[15px] text-white focus:border-[#F5B700] focus:outline-none"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-sm font-medium text-[#c9cdd4]">Password</label>
            <input
              id="admin-password"
              data-testid="admin-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="min-h-[46px] w-full border border-[#3a3d42] bg-[#111111] px-4 py-3 text-[15px] text-white focus:border-[#F5B700] focus:outline-none"
            />
          </div>
          {error && (
            <p role="alert" data-testid="admin-login-error" className="border border-[#C62828] bg-[#2a1414] px-4 py-2.5 text-sm font-medium text-[#ff8a80]">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex min-h-[48px] w-full items-center justify-center gap-2 bg-[#F5B700] px-6 py-3 font-heading text-[15px] font-semibold text-[#111111] hover:bg-[#D99C00] disabled:opacity-60"
          >
            {loading && <Loader2 className="animate-spin" size={17} aria-hidden="true" />}
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <Link to="/" data-testid="admin-back-home" className="mt-6 inline-block text-sm text-[#98a2b3] hover:text-white">
          ← Back to website
        </Link>
      </div>
    </div>
  );
}
